import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import SimpleBar from "simplebar-react";
//import logo
import logoSm from "assets/images/logo-sm.png";
import logoDark from "assets/images/logo-dark.png";
import logoLight from "assets/images/logo-light.png";
import logo from "assets/images/logo/ABGB logo.png";

//Import Components
import VerticalLayout from "./VerticalLayouts/index";
import TwoColumnLayout from "./TwoColumnLayout";
import { Button, Container } from "react-bootstrap";
import HorizontalLayout from "./HorizontalLayout";

const Sidebar = ({ layoutType }: any) => {
  const location = useLocation(); // <-- Detect current route

  useEffect(() => {
    const styleId = "custom-sidebar-active";
    let styleElement = document.getElementById(styleId) as HTMLStyleElement;

    if (!styleElement) {
      styleElement = document.createElement("style");
      styleElement.id = styleId;
      document.head.appendChild(styleElement);
    }

    styleElement.innerHTML = `
    /* Active vertical sidebar menu items */
    #navbar-nav .nav-item.active > .nav-link,
    #navbar-nav .nav-item.show > .nav-link,
    #navbar-nav .nav-link.active,
    #navbar-nav .menu-dropdown.show > .nav-link,
     #navbar-nav .sub-menu li.active > a {
      background-color: #005D97 !important; /* active background color */
      color: white !important;
      border-radius: 10px;               /* text color for contrast */
    }
      

    /* Optional: Hover for inactive items */
    #navbar-nav .nav-item > .nav-link:hover {
      background-color: #f0f0f0 !important;
    }
  `;
  }, []);

  useEffect(() => {
    const styleId = "custom-sidebar-active-color";
    let styleElement = document.getElementById(styleId) as HTMLStyleElement;

    if (!styleElement) {
      styleElement = document.createElement("style");
      styleElement.id = styleId;
      document.head.appendChild(styleElement);
    }

    styleElement.innerHTML = `
    /* Active vertical sidebar menu items */
    #navbar-nav .nav-item.active > .nav-link,
    #navbar-nav .nav-item.show > .nav-link,
    #navbar-nav .nav-link.active,
    #navbar-nav .menu-dropdown.show > .nav-link,
    #navbar-nav .sub-menu li.active > a {
      background-color: #005D97 !important; /* active background color */
      color: white !important;
      border-radius: 10px;               /* text color for contrast */
    }

     #navbar-nav .sub-menu li.active > a: hover {
      background-color: #005D97 !important; /* active background color */
      color: white !important;
      border-radius: 10px;               /* text color for contrast */
    }

    /* Optional: Hover for inactive items */
    #navbar-nav .nav-item > .nav-link:hover {
       background-color: #005D97 !important; /* active background color */
      color: white !important;
      border-radius: 10px;
    }
      /* Dropdown menu background */
#navbar-nav .menu-dropdown {
  background-color: white !important;
}

#navbar-nav .sub-menu {
  background-color: white !important;
}
  `;
  }, []);

  useEffect(() => {
    // Apply inline styles to menu items
    const applyMenuStyles = () => {
      const menuLinks = document.querySelectorAll(
        "#navbar-nav .nav-link, #navbar-nav li a, #navbar-nav .menu-title, #navbar-nav .nav-item span, #navbar-nav li"
      );
      menuLinks.forEach((link: any) => {
        const isActive =
          link.classList.contains("active") || link.closest(".active");

        if (!isActive) {
          link.style.color = "#000000ff"; // only apply to inactive items
        } else {
          link.style.color = ""; // let CSS handle the active color
        }

        link.style.backgroundColor = "transparent";
        link.style.background = "transparent";
      });
    };

    // Apply styles after a short delay to ensure DOM is ready
    setTimeout(applyMenuStyles, 100);

    // Re-apply on route change
    applyMenuStyles();
  }, [location.pathname]);

  const addEventListenerOnSmHoverMenu = () => {
    // add listener Sidebar Hover icon on change layout from setting
    if (
      document.documentElement.getAttribute("data-sidebar-size") === "sm-hover"
    ) {
      document.documentElement.setAttribute(
        "data-sidebar-size",
        "sm-hover-active"
      );
    } else if (
      document.documentElement.getAttribute("data-sidebar-size") ===
      "sm-hover-active"
    ) {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    } else {
      document.documentElement.setAttribute("data-sidebar-size", "sm-hover");
    }
  };

  const handleOverlayClick = () => {
    // Close sidebar on mobile when clicking overlay
    const windowSize = document.documentElement.clientWidth;
    if (windowSize <= 767) {
      document.body.classList.remove("vertical-sidebar-enable");
    }
  };

  return (
    <React.Fragment>
      <div
        className="app-menu navbar-menu"
        style={{
          backgroundColor: "white",
          borderRight: "none",
          color: "black",
        }}
      >
        <div className="navbar-brand-box" style={{ backgroundColor: "white" }}>
          <Link
            to={process.env.PUBLIC_URL + "/"}
            className="logo logo-light"
            style={{
              backgroundColor: "white",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <span className="logo-lg">
              <img
                src={logo}
                alt="Prime ABGB"
                style={{
                  height: "40px",
                  width: "auto",
                  maxWidth: "160px",
                  objectFit: "contain",
                }}
              />
            </span>
            <span className="logo-sm">
              <img
                src={logo}
                alt="Prime ABGB Small"
                style={{
                  height: "30px",
                  width: "auto",
                  maxWidth: "65px",
                  objectFit: "contain",
                }}
              />
            </span>
          </Link>

          <Button
            variant="link"
            size="sm"
            onClick={addEventListenerOnSmHoverMenu}
            type="button"
            className="btn p-0 fs-3xl header-item float-end btn-vertical-sm-hover"
            id="vertical-hover"
            style={{ color: "#000" }}
          >
            <i className="ri-record-circle-line"></i>
          </Button>
        </div>

        {/* Sidebar content */}
        <SimpleBar
          id="scrollbar"
          className="h-100"
          style={{ backgroundColor: "white", color: "black" }}
        >
          <Container fluid>
            <ul className="navbar-nav" id="navbar-nav">
              <VerticalLayout
                layoutType={layoutType}
                currentPath={location.pathname}
              />
            </ul>
          </Container>
        </SimpleBar>

        <div
          className="sidebar-background"
          style={{ backgroundColor: "white" }}
        ></div>
      </div>

      <div
        className="vertical-overlay"
        onClick={handleOverlayClick}
        style={{
          cursor: "pointer",
        }}
      ></div>
    </React.Fragment>
  );
};

export default Sidebar;
